<template>
  <v-app id="mobilepreview">
    <div style="margin: 20px; background: #e8e8ff">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="fullPage"
      ></loading>
      <div
        v-if="
          imagelist[0].file_type == 'jpeg' ||
          imagelist[0].file_type == 'jpg' ||
          imagelist[0].file_type == 'png' ||
          imagelist[0].file_type == 'gif' ||
          imagelist[0].file_type == 'image'
        "
      >
        <img
          style="marging: 5px; padding: 8px; cursor: pointer"
          :src="imagelist[0].downlaod_url"
        />
      </div>
      <div
        v-if="
          imagelist[0].file_type == 'mpeg-4' ||
          imagelist[0].file_type == 'mp4' ||
          imagelist[0].file_type == 'video'
        "
      >
        <video
          width="500"
          height="300"
          align="left"
          controls
          :src="imagelist[0].downlaod_url"
        ></video>
      </div>
    </div>
  </v-app>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "MobilePreview",
  components: {
    Loading,
  },
  data: () => ({
    isLoading: false,
    imagelist: [],
    defaultcolor: "border:4px solid green",
    rotatingmessage: "",
    redirect_url: "",
    product_type: "MobileProduct",
    product_status: "",
  }),
  mounted() {
    var view = this;
    if (this.$route.query.product_type !== undefined)
      this.product_type = this.$route.query.product_type;
    if (this.$route.query.product_status !== undefined)
      this.product_status = this.$route.query.product_status;
    view.view_images(view.$route.params.product_id);
    view.redirect_url = view.$url("TEMP_PRODUCT_LISTING");
  },
  methods: {
    /**
     * @desc:endpoint for returning images of pdf page by page
     * @return array
     */

    view_images: function (product_id) {
      var view = this;
      view.isLoading = true;
      let creative_id = "";
      var endPoint = "";
      if (view.$route.query.creative_id !== undefined) {
        creative_id = view.$route.query.creative_id;
        endPoint =
          view.$url("VIEW_PDF_IMAGES") +
          "?product_id=" +
          "&product_type=" +
          this.product_type +
          "&product_status=" +
          this.product_status +
          "&creative_id=" +
          creative_id;
      } else {
        endPoint =
          view.$url("VIEW_PDF_IMAGES") +
          "?product_id=" +
          product_id +
          "&product_type=" +
          this.product_type +
          "&product_status=" +
          this.product_status;
      }

      view
        .$fetch(
          {
            url: endPoint,
            type: "GET",
            contentType: "application/json",
          },
          {
            operation: "add",
            vueScope: view,
          }
        )
        .then(function (r) {
          console.log(r);
          view.isLoading = false;
          view.imagelist = r.payload;
        })
        .catch(function (e) {
          view.isLoading = false;
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: e.responseJSON.payload.msg,
          });
        });
    },
    /**
     *
     */
    rotateImage: function (product_id, image_sort) {
      var view = this;
      view.isLoading = true;
      var endPoint =
        view.$url("ROTATE_IMAGES") +
        "?product_id=" +
        product_id +
        "&document_sort=" +
        image_sort;
      view
        .$fetch(
          {
            url: endPoint,
            type: "GET",
            contentType: "application/json",
          },
          {
            operation: "add",
            vueScope: view,
          }
        )
        .then(function (r) {
          console.log(r);
          view.view_images(product_id);
          view.isLoading = false;
        })
        .catch(function (e) {
          console.log(e);
          view.isLoading = false;
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: "Product Image not created",
          });
        });
    },
    /**
     *
     */
    setDefaultProductImage: function (product_id, image_sort) {
      var view = this;
      view.isLoading = true;
      let token = view.$utils.getAccessToken();
      let formData = new FormData();
      formData.append("product_id", product_id);
      var endPoint =
        view.$url("ROTATE_IMAGES") +
        "?product_id=" +
        product_id +
        "&document_sort=" +
        image_sort;
      axios
        .post(endPoint, formData, {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
            userid: view.$utils.getCookies("user_id"),
          },
        })
        .then(function () {
          view.view_images(product_id);
          view.isLoading = false;
          view.rotatingmessage = "";
          //window.open(view.redirect_url, '_blank');
        });
    },
    /**
     *
     */
    open_uploaded_pdf() {
      var view = this;
      let product_id = view.$route.params.product_id;
      window.open(
        view.$url("DIRECT_MAIL_PDF_URL") +
          "?product_id=" +
          product_id +
          "&isproduct_pdf=1",
        "_blank"
      );
    },
  },
};
</script>

<style lang='sass' scoped>
@import './../assets/sass/company'
</style>